namespace TabAurous.ProductDevelopment {
    export namespace PDQuotationAdditionalChargesService {
        export const baseUrl = 'ProductDevelopment/PDQuotationAdditionalCharges';

        export declare function Create(request: Serenity.SaveRequest<PDQuotationAdditionalChargesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PDQuotationAdditionalChargesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PDQuotationAdditionalChargesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PDQuotationAdditionalChargesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/PDQuotationAdditionalCharges/Create",
            Update = "ProductDevelopment/PDQuotationAdditionalCharges/Update",
            Delete = "ProductDevelopment/PDQuotationAdditionalCharges/Delete",
            Retrieve = "ProductDevelopment/PDQuotationAdditionalCharges/Retrieve",
            List = "ProductDevelopment/PDQuotationAdditionalCharges/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PDQuotationAdditionalChargesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
